import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(({ spacing, palette, zIndex }) => ({
  popper: {
    // Portalled to <body> with no stacking of its own, so the fields' floating
    // labels (z-index 1) showed through wherever it overlapped them.
    zIndex: zIndex.tooltip,
    width: 185,
    borderRadius: spacing(1),
    border: "1px solid #CCCCCC",
    backgroundColor: "#FFFFFF",
    padding: spacing(1, 2, 1, 1.5),
    display: "flex",
    flexDirection: "column",
    gap: spacing(1.25),
  },
  popperIcon: {
    width: 20,
    height: 20,
  },
  infoIcon: {
    width: 16,
    height: 16,
  },
  toggleIcon: {
    color: `${palette.defaultSideText.main} !important`,
    fill: `${palette.defaultSideText.main} !important`,
  },
  helperText: { margin: 0, marginTop: spacing(0.5) },
}));

export default styles;
